import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const StyledEmptyRequests = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  border: 1px dashed #cccad7;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textCaption};
  text-align: center;
`

const EmptyRequests = () => {
  const { t } = useTranslation()
  return <StyledEmptyRequests>{t('no_withdrawal_request')}</StyledEmptyRequests>
}

export default EmptyRequests
